module.exports = __webpack_public_path__ + "img/Nigeria.54a31c06.png";